<!--Element多选树形控件-->
<template>
	<div class="el_Tree_Body" :style="bodyStyle">
		<div class="elTree_hideButton">
			<div class="elTree_hideButton1" v-show="isShow" @click="isShow=!isShow">
				<el-button size="mini" icon="iconfont iconleft_shousuo"></el-button>
			</div>
			<div class="elTree_hideButton2" v-show="!isShow" @click="isShow=!isShow">
				<el-button size="mini" icon="iconfont iconrigth_shousuo"></el-button>
			</div>
		</div>
		<transition name="el-zoom-in-center">
			<div v-show="isShow" class="elTree_body">
				<h2 style="display: flex;padding-top:10px;align-items: center;">{{columns}}</h2>
				<div style="display: flex;padding-top:10px;align-items: center;">
					<el-input placeholder="输入关键字进行过滤" v-model="filterText" size="small" style='width: 180px;margin-left: 15px;'>
					</el-input>
				</div>
				<el-scrollbar style="height:95%;width: 100%;">
					<!--2020-10-13 lxk 去掉:default-checked-keys="defaultDeviceList"和:default-expanded-keys="defaultDeviceList"-->
					<!--<el-tree :data="data" :expand-on-click-node="false" show-checkbox node-key="pkid" :accordion="true" :default-expanded-keys="defaultDeviceList" :default-checked-keys="defaultDeviceList" :props="defaultProps" @check-change="nodeClick" :highlight-current='true'  :filter-node-method="filterNode" ref="tree">-->
			<el-tree :data="data" :expand-on-click-node="false"  show-checkbox node-key="pkid" :accordion="true" :props="defaultProps" @check-change="nodeClick" :highlight-current='true' :filter-node-method="filterNode" ref="tree">
			   <span class="custom-tree-node" slot-scope="{node, data}">
			    <img src="../../../../public/static/image/elTree/1.9.png" v-show="node.data.type=='group'&&node.data.unitid!=''"/>
			 	<img src="../../../../public/static/image/elTree/2.0.png" v-show="node.data.type=='group'&&node.data.unitid==''"/>
			 	<img src="../../../../public/static/image/elTree/2.1.png" v-show="node.data.type=='virtualDevice'"/>
			 	<span style="padding-left: 5px;">{{node.label }}</span>
						</span>
			</el-tree>
				</el-scrollbar>
			</div>
		</transition>
	</div>
</template>
<script>
	export default {
		components: {},
		props: {
			dataList: {
				type: Array,
				required: true,
				default: []

			},
			columns: ""
		},
		data() {
			return {
				filterText: '',
				data: [],
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				defaultDevice: {},
				isShow: true,
			}
		},
		created() {},
		mounted() {
			if(!isempty(this.dataList)) {
				//debugger
				this.data = this.dataList
			}
		},
		activated() {
			let tempList = [];
			this.$emit('checkItem', tempList)
			this.$store.deviceStore.commit('setNowVirtualDeviceList', tempList)
			let list = this.$refs.tree.getCheckedNodes()
		},
		destroyed() {},
		computed: {
			bodyStyle() {
				let width = '0px'
				if(this.isShow) {
					width = '2.5rem'
				}
				return {
					"width": width
				}
			},
			getResourcesByName() {
				//debugger
				return this.$store.resourcesStore.getters.getResourcesByName
			},
			nowVirtualDeviceList() {
				//debugger
				return this.$store.deviceStore.state.nowVirtualDeviceList
			},

			defaultDeviceList() {
				//debugger
				let list = this.nowVirtualDeviceList
				let listDevice = []
				let idList = []
				if(isempty(list)) {
					if(!isempty(this.dataList)) {
						this.digui(this.dataList)
					}
				} else {
					list.forEach(item => {
						listDevice.push(item)
						idList.push(item.pkid)
					})
				}
				if(!isempty(idList)) {
					this.$emit('checkItem', listDevice)
				}
				return idList
			}
		},
		watch: {
			filterText(val) {
				//debugger
				this.$refs.tree.filter(val);
			},
			dataList(nv, ov) {
				//debugger
				if(!isempty(nv)) {
					this.data = this.dataList
				}
			}
		},
		methods: {
			filterNode(value, data) {
				//debugger
				if(!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			bindunBeforUnload() {
				debugger
				let tempList = [];
				this.$emit('checkItem', tempList)
				this.$store.deviceStore.commit('setNowVirtualDeviceList', tempList)
				let list = this.$refs.tree.getCheckedNodes()
			},
			nodeClick() {
				//debugger
				let list = this.$refs.tree.getCheckedNodes()
				list.forEach(item => {
					item.name = item.lable
				})
				this.$emit('checkItem', list)
				this.$store.deviceStore.commit('setNowVirtualDeviceList', list)
			},
			digui(list) {
				//debugger
				list.forEach(item => {
					if(!isempty(item.children)) {
						this.digui(item.children)
					} else {
						if(item.type == 'virtualDevice') {
							if(isempty(this.nowVirtualDeviceList)) {
								this.$store.deviceStore.commit('setNowVirtualDeviceList', [item])
							}
						}
					}
				})
			}
		}
	}
</script>

<style>
</style>